var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},[_c('ul',{staticClass:"pagination-list"},_vm._l((_vm.pagination),function(i){return _c('li',{key:i,staticClass:"pagination-item"},[_c('button',{staticClass:"pagination-btn",class:{ 
          'active-btn-pagination': i === (_vm.currentPage + 1),
          'pagination--dots': i === '...'},attrs:{"disabled":i === '...'},on:{"click":function($event){return _vm.setPage(i)}}},[_vm._v(" "+_vm._s(i)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }